"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFolderTree = exports.getSelectedFolderAncestors = exports.getParentFolderForFile = exports.getFolderById = exports.getCurrentFolder = exports.getSelectedFolder = exports.getFoldersCount = exports.getFolders = exports.findFolderByPath = exports.findFolderById = void 0;

var _reselect = require("reselect");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var getFolderPath = function getFolderPath(state) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var folderPath = props.folderPath || props.params && props.params.splat;

  if (folderPath) {
    return "/" + folderPath;
  }

  return null;
};

var getFolderIdFromProps = function getFolderIdFromProps(state, props) {
  return props.folderId;
};

var findFolderById = function findFolderById(folders, id) {
  return id && folders.find(function (folder) {
    return folder.get('id') === id;
  });
};

exports.findFolderById = findFolderById;

var findFolderByPath = function findFolderByPath(folders, path) {
  if (!path) {
    return null;
  }

  return folders.find(function (folder) {
    return folder.get('full_path') === path;
  });
};

exports.findFolderByPath = findFolderByPath;

var getFolders = function getFolders(state) {
  return state.folders.get('objects');
};

exports.getFolders = getFolders;

var getFoldersCount = function getFoldersCount(state) {
  return state.folders.get('total');
};

exports.getFoldersCount = getFoldersCount;

var getSelectedFolder = function getSelectedFolder(state, props) {
  return props.selectedFolder;
};

exports.getSelectedFolder = getSelectedFolder;
var getCurrentFolder = (0, _reselect.createSelector)([getFolders, getFolderPath], findFolderByPath);
exports.getCurrentFolder = getCurrentFolder;
var getFolderById = (0, _reselect.createSelector)([getFolders, getFolderIdFromProps], findFolderById);
exports.getFolderById = getFolderById;

var getFileFromProps = function getFileFromProps(state, props) {
  return props.file;
};

var getParentFolderForFile = (0, _reselect.createSelector)([getFileFromProps], _FoldersAndFiles.getParentFolder);
exports.getParentFolderForFile = getParentFolderForFile;
var getSelectedFolderAncestors = (0, _reselect.createSelector)([getSelectedFolder, getFolders], _FoldersAndFiles.getAncestors);
exports.getSelectedFolderAncestors = getSelectedFolderAncestors;
var getFolderTree = (0, _reselect.createSelector)([getFolders], _FoldersAndFiles.makeFolderTree);
exports.getFolderTree = getFolderTree;